module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjBAMAAADs965qAAAAIVBMVEUJBQlHcEwJBQkJBQkJBQkKBgoRDhEJBQkNCQ0JBQkJBQn6iUojAAAACnRSTlNAAL+A5Woeti6gUxXcJgAAAKtJREFUKM9jEBRMYIADRkFBQQEGQeFVCLCkESwkhSS0aiJEaKEgHFgpEiW0agkjhtAqR6iQmBIYJFopcC2EColC7Au0UpSCCQlCXCqILAS3kSQhMZivEULiMB8ibBRVgoJGEo2XhJnFiE8I6h0GDrxmCUDdoJ4IFxLCdKqYMQSYUh44CxBpYhZESAQ5ARiChQS8ECLLBcFCgoJCCxCm4RYSRzYNIoRs2ipDAQCTgJcMyViRRAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doc.png
// module id = YAyH
// module chunks = 1